import { Component, ChangeDetectionStrategy } from "@angular/core";
import { MapFastighetComponent } from "~app/common/components/map/components/menu/map-fastighet/map-fastighet.component";
import { MapFullscreenComponent } from "~app/common/components/map/components/menu/map-fullscreen/map-fullscreen.component";
import { MapLayersComponent } from "~app/common/components/map/components/menu/map-layers/map-layers.component";
import { MapMeasureComponent } from "~app/common/components/map/components/menu/map-measure/map-measure.component";
import { MapComponent } from "~app/common/components/map/map.component";
import { IMapSettings } from "~app/common/components/map/map.settings";
import { KartaFeaturelayers } from "~app/common/models/constants";

@Component({
    selector: "rask-fristaende-virkeskopskarta",
    templateUrl: "./fristaende-virkeskopskarta.component.html",
    styleUrls: ["./fristaende-virkeskopskarta.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        MapComponent,
        MapFastighetComponent,
        MapMeasureComponent,
        MapFullscreenComponent,
        MapLayersComponent
    ]
})
export class FristaendeVirkeskopsKartaComponent {
    mapsettings: IMapSettings = {
        id: "virkeskop",
        height: "100%",
        mapVerticalStart: null,
        center: [
            16.1932,
            62.2315
        ],
        zoom: 0,
        baselayers: [
            { id: "metriabakgrund",
                visible: true },
            { id: "metriaorto",
                visible: true }
        ],
        featurelayers: [
            { id: KartaFeaturelayers.Historto,
                visible: false },
            { id: KartaFeaturelayers.Infrarodorto,
                visible: false },
            { id: KartaFeaturelayers.Satellitbilder },
            { id: KartaFeaturelayers.Drone },
            { id: KartaFeaturelayers.SmittadZonSjv },
            { id: KartaFeaturelayers.Collector,
                visible: false },
            { id: KartaFeaturelayers.Springfield,
                visible: false },
            { id: KartaFeaturelayers.Arboreal,
                visible: true },
            { id: KartaFeaturelayers.Virkeskop,
                visible: true },
            { id: KartaFeaturelayers.Virkeskop_historiska,
                visible: false },
            { id: KartaFeaturelayers.MetriaFastighetsgranser,
                visible: true },
            { id: KartaFeaturelayers.Restriktioner,
                visible: true },
            { id: KartaFeaturelayers.FornKulturminnen,
                visible: true },
            { id: KartaFeaturelayers.VerkGemAdminGrans,
                visible: true },
            { id: KartaFeaturelayers.VerkGemLLD,
                visible: true },
            { id: KartaFeaturelayers.VerkGemFastigheter,
                visible: true },
            { id: KartaFeaturelayers.VerkGemSamfalligheter,
                visible: true },
            { id: KartaFeaturelayers.VerkGemLKF,
                visible: true },
            { id: KartaFeaturelayers.VerkGemFaktaExternVindkraft,
                visible: true },
            { id: KartaFeaturelayers.VerkGemFaktaBelastningar,
                visible: true },
            { id: KartaFeaturelayers.Vagar,
                visible: true },
            { id: KartaFeaturelayers.VFS_PlaneradVag,
                visible: true },
            { id: KartaFeaturelayers.Laserprodukter,
                visible: true },
            { id: KartaFeaturelayers.EgenSkog,
                visible: true },
            { id: KartaFeaturelayers.StinaKorstrak,
                visible: false },
            { id: KartaFeaturelayers.StinaGrotpunkter,
                visible: false },
            { id: KartaFeaturelayers.StinaHansyn,
                visible: false },
            { id: KartaFeaturelayers.StinaEgenritadeObjekt,
                visible: false },
            { id: KartaFeaturelayers.SKS_Avverkningsanmalningar,
                visible: false },
            { id: KartaFeaturelayers.SKS_UtfordAvverkning,
                visible: false },
            { id: KartaFeaturelayers.Renskotselomraden,
                visible: false }
        ],
        scaleBar: true,
        zoomButtons: true,
        coords: true,
        drawLayers: [],
        mediaLayers: []
    };
}
